import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyDmU9B32LCEXGMtjTO1XYF-OuygIfPjOoo",
    authDomain: "getfreelancepay.firebaseapp.com",
    projectId: "getfreelancepay",
    storageBucket: "getfreelancepay.firebasestorage.app",
    messagingSenderId: "1002034501125",
    appId: "1:1002034501125:web:36348f538b4255e4e1ee6c",
    measurementId: "G-DPBTDJF76M",
    databaseURL: "https://getfreelancepay.firebaseio.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);

export default app;